import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { HomeUsesParams } from './service';

export enum HomeUsesActions {
  Failure = '[Catalogs HomeUses] Failure',
  Request = '[Catalogs HomeUses] Request',
  Success = '[Catalogs HomeUses] Success',
}

export const HomeUsesFailure = createAction(HomeUsesActions.Failure, props<{ error: HttpErrorResponse }>());

export const HomeUsesRequest = createAction(HomeUsesActions.Request, props<{ parameters?: HomeUsesParams }>());

export const HomeUsesSuccess = createAction(HomeUsesActions.Success, props<{ data: ParameterResult[] }>());
